import Vue from 'vue'
import I18n from 'vue-i18n'
import cn from './locales/cn'
import en from './locales/en'

Vue.use(I18n)

export default new I18n({
  locale: localStorage.lang || 'cn',
  messages: {
    cn,
    en
  }
})